export default {"src":"/_next/static/media/join-waitlist-modal-bg.92495dda.svg","height":347,"width":346,"blurWidth":0,"blurHeight":0};